import { Pipe, PipeTransform } from '@angular/core';

/**
 * @deprecated use ngPlural instead
 */
@Pipe({
  name: 'addPlural',
  standalone: true,
})
export class AddPluralPipe implements PipeTransform {

  transform(value: number | string = 0, ...args: string[]): string {
    value = typeof value === 'string' ? parseInt(value, 10) : value;

    return value + ' ' + (value === 1 ? args[0] : args[0] + 's');
  }

}
